import { Card, Button } from 'react-bootstrap'
import history from 'utils/history'
import {
  GlobalOutlined, UserAddOutlined, PhoneOutlined, LinkOutlined,
} from '@ant-design/icons'

const MitraCard = ({
  url, name, registUrl,
  phone, guideUrl, logo,
}) => (
  <Card className="mitra-card">
    <Card.Body className="text-center">
      <div className="mb-3">
        {logo
          && <img className="mitra-card-logo" src={logo} alt="logo" />
        }
      </div>
      <div className="btn-black">
        <Button variant="dark" onClick={() => history.push(registUrl || '')}>Masuk</Button>
      </div>
      <div className="my-3">
        <h6 className="mitra-link font-weight-bold">{name}</h6>
        <a className="mitra-link" href={url || '#'} target="_blank" rel="noreferrer">{url}</a>
        <a className="mitra-link" href={registUrl || '#'} target="_blank" rel="noreferrer">
          <UserAddOutlined className="mr-1" />
          Daftar Sebagai Penyedia
        </a>
        <p className="mitra-link" href="">
          <PhoneOutlined className="mr-1" />
          {phone}
        </p>
        <a className="mitra-link" href={guideUrl || '#'} target="_blank" rel="noreferrer">
          <LinkOutlined className="mr-1" />
          Klik Panduan
        </a>
      </div>
    </Card.Body>
  </Card>
)
export default MitraCard
